export const HOME_STATS = {
  loginUsers: 1286,
  businessTopics: 42,
  sharedTemplates: 38,
  classicCases: 24,
}

export const QUICK_START = [
  { id: 'quick-1', title: '快速入门教程', icon: '🚀', link: '#' },
  { id: 'quick-2', title: '用户手册', icon: '📖', link: '#' },
]

export interface LatestTopic {
  id: string
  name: string
  description: string
  department: string
  catalogId?: string
}

export const LATEST_TOPICS: LatestTopic[] = [
  { id: 'topic-payroll', name: '代发客群资金交易明细主题', description: '代发客户工资流水、余额变动、资金留存等交易明细分析', department: '零售金融部', catalogId: 'retail-customer' },
  { id: 'topic-corp-deposit', name: '对公大额存款变动情况', description: '对公客户大额存款余额变动日报，支持按客户、机构、管户经理维度分析', department: '公司金融部', catalogId: 'retail-deposit' },
  { id: 'topic-1', name: '客户资金流向分析', description: '追踪客户资金流转路径，识别异常交易模式', department: '零售银行部', catalogId: 'retail-customer' },
  { id: 'topic-2', name: '信贷资产质量监测', description: '实时监控信贷资产质量变化趋势', department: '风险管理部', catalogId: 'risk-credit' },
  { id: 'topic-3', name: '对公客户画像分析', description: '构建企业客户多维画像，支持精准营销', department: '公司银行部', catalogId: 'corporate' },
  { id: 'topic-4', name: '金融市场业务分析', description: '同业业务、债券投资等金融市场数据分析', department: '金融市场部', catalogId: 'market-bond' },
  { id: 'topic-5', name: '监管报送数据核对', description: '一表通报送数据质量核对与差异分析', department: '计划财务部', catalogId: 'regulatory-east' },
  { id: 'topic-6', name: '零售存款业务分析', description: '存款规模、结构、利率变动趋势分析', department: '零售银行部', catalogId: 'retail-deposit' },
]

export const TOP_TEMPLATES = [
  { rank: 1, name: '对公大额存款变动情况', introduction: 'T+1日统计当日对公客户大额存款余额变动情况，并展示最大一笔跨行转出交易对手，助您及时了解客户资金动向', templateId: '1' },
  { rank: 2, name: '一年期及以下对公存款日均增量', introduction: 'T+1日统计各机构对公客户存款时点与年日均，并提供比上日、比上月、比上季、比年初的比值，您可直观了解存款时点与日均的变化情况', templateId: '12a' },
  { rank: 3, name: '公司价值户净增', introduction: 'T+1日统计各机构基础客户、价值客户、高价值客户、核心客户的时点户数及净增情况，助您及时了解辖内各等级客户现状', templateId: '102' },
  { rank: 4, name: '一年期及以下个人存款日均增量', introduction: 'T+1日统计各机构个人客户存款时点与年日均，并提供比上日、比上月、比上季、比年初的比值，您可直观了解存款时点与日均的变化情况', templateId: '12b' },
  { rank: 5, name: '普惠贷款增量', introduction: 'T+1日展示辖内普惠小微客户贷款明细，数据取自信贷系统、个贷系统，其中客户单户余额是指该客户名下各借据时点贷款余额的汇总，跨系统数据助您一键获取', templateId: '101' },
  { rank: 6, name: '对公客户等级变动提醒', introduction: '对公客户等级升降变动监测与提醒', templateId: '103' },
  { rank: 7, name: '零售自营理财及非存款', introduction: '零售自营理财及非存款产品规模、收益统计', templateId: '105' },
  { rank: 8, name: '个人大额存款变动', introduction: '个人客户大额存款余额变动监测与预警', templateId: '111' },
  { rank: 9, name: '零售理财到期明细', introduction: '零售客户理财产品到期明细及续接情况', templateId: '112' },
  { rank: 10, name: '重点产品销量统计', introduction: '重点零售产品销量及排名统计', templateId: '115' },
  { rank: 11, name: '个人基础及以上客户净增明细', introduction: 'T+1日展示辖内个人基础及以上净增客户，个人基础客户是指近90天AUM日均在1000元及以上的客户（不含二类、三类户及存量纯社保医保客户）', templateId: '106' },
]

export interface RecentItem {
  id: string
  name: string
  type: 'report' | 'topic'
  department?: string
  lastAccessed?: string
}

export const RECENT_REPORTS: RecentItem[] = [
  { id: 'rpt-1', name: '代发客群营销分析', type: 'report', department: '零售金融部', lastAccessed: '2024-03-20' },
  { id: 'rpt-2', name: '对公大额存款变动情况', type: 'report', department: '公司金融部', lastAccessed: '2024-03-19' },
  { id: 'rpt-3', name: '客户流失分析报表', type: 'report', department: '零售银行部', lastAccessed: '2024-03-18' },
  { id: 'rpt-4', name: '反欺诈交易日报', type: 'report', department: '风险管理部', lastAccessed: '2024-03-17' },
  { id: 'rpt-5', name: '分支行业绩考核月报', type: 'report', department: '计划财务部', lastAccessed: '2024-03-16' },
]

export const RECENT_TOPICS: RecentItem[] = [
  { id: 'topic-payroll', name: '代发客群资金交易明细主题', type: 'topic', department: '零售金融部', lastAccessed: '2024-03-20' },
  { id: 'topic-corp-deposit', name: '对公大额存款变动情况', type: 'topic', department: '公司金融部', lastAccessed: '2024-03-19' },
  { id: 'topic-3', name: '对公客户画像分析', type: 'topic', department: '公司银行部', lastAccessed: '2024-03-18' },
  { id: 'topic-5', name: '监管报送数据核对', type: 'topic', department: '计划财务部', lastAccessed: '2024-03-17' },
  { id: 'topic-6', name: '零售存款业务分析', type: 'topic', department: '零售银行部', lastAccessed: '2024-03-16' },
]

export const PARTNER_TEMPLATES: RecentItem[] = [
  { id: 'pt-1', name: '代发客群营销分析', type: 'report', department: '零售金融部' },
  { id: 'pt-2', name: '对公大额存款变动情况', type: 'report', department: '公司金融部' },
  { id: 'pt-3', name: '对公业务效能分析模板', type: 'report', department: '公司银行部' },
  { id: 'pt-4', name: '财富管理产品分析模板', type: 'report', department: '财富管理部' },
  { id: 'pt-5', name: '分支机构经营分析模板', type: 'report', department: '计划财务部' },
]

export const PARTNER_TOPICS: RecentItem[] = [
  { id: 'topic-payroll', name: '代发客群资金交易明细主题', type: 'topic', department: '零售金融部' },
  { id: 'topic-corp-deposit', name: '对公大额存款变动情况', type: 'topic', department: '公司金融部' },
  { id: 'topic-3', name: '对公客户画像分析', type: 'topic', department: '公司银行部' },
  { id: 'topic-5', name: '监管报送数据核对', type: 'topic', department: '计划财务部' },
  { id: 'topic-6', name: '零售存款业务分析', type: 'topic', department: '零售银行部' },
]
